import React from "react";
import { BarChartItem } from "../../Types/dashboardTypes";

interface Props {
  data: BarChartItem[];
  colorTheme: string[];
}

const MyLegend: React.FC<Props> = (props) => {
  return (
    <div className="legend-grid">
      {props.data.map((e, index: number) => {
        return (
          <React.Fragment key={index}>
            <div
              className={`legend-color`}
              style={{
                height: 24,
                width: 24,
                backgroundColor: props.colorTheme[index],
                borderRadius: 8,
              }}
            />
            <div className={`legend-text`}>{e.legendName}</div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default MyLegend;
